import React from 'react';
import { QueryParameterContext } from './QueryParameterContext';
import { StaticPropsContextProvider, StaticProps } from './StaticPropsContext';
import { SearchResultContextProvider } from './SearchResultContext';

interface ApplicationExportContextProvider {
  children: React.ReactNode;
  initialProps: StaticProps;
}

export function ApplicationExportProvider(props: ApplicationExportContextProvider) {
  return (
    <StaticPropsContextProvider initialProps={props.initialProps}>
      <QueryParameterContext>
        <SearchResultContextProvider>{props.children}</SearchResultContextProvider>
      </QueryParameterContext>
    </StaticPropsContextProvider>
  );
}
